<template>
  <div>
    <table-render
      id="AuditorConnectTable"
      :loading="false"
      :schema="schema"
      :rows="dataTableAuditorConnect.rows"
    />
  </div>
</template>

<script>
export default {
  name: 'AuditorConnectTable',
  props: {
    dataTableAuditorConnect: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      schema: []
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    setInitialData() {
      this.schema = [
        {label: 'Origen', key: 'place_name_from'},
        {label: 'Destino', key: 'place_name_to'}
      ]
      this.arrayCurrentKgs = this.dataTableAuditorConnect?.rows[0]?.lowest_intervals ? Object.keys(this.dataTableAuditorConnect.rows[0].lowest_intervals) : []
      this.arrayCurrentKgs = this.arrayCurrentKgs.sort(function (a, b) {
        return parseFloat(a) - parseFloat(b)
      })
      this.arrayCurrentKgs.forEach((el) => {
        this.schema.push({
          label: `Precio (${el}kg)`,
          key: `${el}kg`,
          class: ['text-right']
        })
      })
    }
  }
}
</script>